import {useRecordContext} from "react-admin";
import Chip from "@mui/material/Chip";
import React from "react";

export const ProviderTypesField = () => {
    const record = useRecordContext();
    return (
        <ul style={{listStyle:"none", marginBottom:"2px", display: "flex"}}>
            {record.care_types?.map(item => (
                <li key={item}><Chip label={item} /></li>
            ))}
        </ul>
    )
};
